import { LinearProgress, withStyles } from '@material-ui/core';
import {loaderColor, loaderBarColor} from '../Config/ProgressBar.constants';

export default withStyles({
    root: {
        height: '6px',
        background: loaderColor,
        borderRadius: '5px'
    },
    bar: {
        height: '6px',
        background: loaderBarColor,
        borderRadius: '5px'
    }
})(LinearProgress);
